var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDotsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 8.83398C2.46026 8.83398 2.83335 8.46089 2.83335 8.00065C2.83335 7.54041 2.46026 7.16732 2.00002 7.16732C1.53978 7.16732 1.16669 7.54041 1.16669 8.00065C1.16669 8.46089 1.53978 8.83398 2.00002 8.83398Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 3.00065C2.46026 3.00065 2.83335 2.62755 2.83335 2.16732C2.83335 1.70708 2.46026 1.33398 2.00002 1.33398C1.53978 1.33398 1.16669 1.70708 1.16669 2.16732C1.16669 2.62755 1.53978 3.00065 2.00002 3.00065Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00002 14.6673C2.46026 14.6673 2.83335 14.2942 2.83335 13.834C2.83335 13.3737 2.46026 13.0007 2.00002 13.0007C1.53978 13.0007 1.16669 13.3737 1.16669 13.834C1.16669 14.2942 1.53978 14.6673 2.00002 14.6673Z",
    stroke: "#98A2B3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsIcon);
export default __webpack_public_path__ + "static/media/three-dots-icon.cb6ec0f4c6a332e6bc92b5b8b935f39c.svg";
export { ForwardRef as ReactComponent };